import { Component, OnDestroy, OnInit } from '@angular/core';
import { WorkflowDto } from '../../../service/dto';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpWorkflowService } from '../../../service/http-workflow.service';
import { of, Subscription, switchMap } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { doGetInvalidControlsList, doTouchAllFields, WrapperWorkflowDto, WrapperWorkflowStepDto } from './workflow-utils';
import { DraftService } from '../../../service/draft.service';
import { NzMessageService } from 'ng-zorro-antd/message';




@Component({
	selector: 'app-workflow-form',
	standalone: false,
	templateUrl: './workflow-form.component.html',
	styleUrl: './workflow-form.component.scss'
})
export class WorkflowFormComponent implements OnInit, OnDestroy {
	static idCounter = (Date.now()) * -1;
	subscription = new Subscription();
	workflow?: WrapperWorkflowDto;
	selectedStepIndex = 0;
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private httpService: HttpWorkflowService,
		private fb: FormBuilder,
		private draftService: DraftService,
		private messageService: NzMessageService) {
	}
	public static getNextId(): number {
		return --this.idCounter;
	}

	ngOnInit(): void {
		this.subscription.add(this.activatedRoute.paramMap.subscribe(paramMap => {
			const id = paramMap.get('id');
			this.draftService.prompt<WorkflowDto>('workflow', id == undefined ? undefined : (+id))
				.pipe(switchMap(item => {
					if (item == false) {
						return this.fetchOrCreateWorkflow(id);
					}
					return of(item);
				}))
				.subscribe(result => {
					this.workflow = this.init(result);
				});
		}));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	private fetchOrCreateWorkflow(id: string | null) {
		if (id) {
			return this.httpService.get(+id);
		} else {
			return this.httpService.newWorkflow();
		}
		// if (id) {
		// 	this.httpService.get(+id).subscribe(result => {
		// 		this.workflow = this.init(result);
		// 	});
		// } else {
		// 	this.httpService.newWorkflow().subscribe(result => {
		// 		this.workflow = this.init(result);
		// 	});
		// }
	}
	init(input: WorkflowDto): WrapperWorkflowDto | undefined {
		const out = new WrapperWorkflowDto();
		const steps = input.steps.map(item => WrapperWorkflowStepDto.create(this.fb, out, item, item.readOnlyFields))
			.sort((i1, i2) => {
				if (i1._stepOrder && i2._stepOrder) {
					return i1._stepOrder - i2._stepOrder;
				}
				if (i1._stepOrder) {
					return -1;
				}
				return 1;
			});
		const form = this.fb.group({
			id: [input.id],
			name: [input.name, [Validators.required]], //Add unique check
			label: [input.label, [Validators.required]],
			description: [input.description, [Validators.required]],
			autoAssign: [input.autoAssign],
			linkMemberships: [input.linkMemberships],
			ticketMode: [input.ticketMode, Validators.required],
			linkToOtherTicketEnabled: [input.linkToOtherTicketEnabled],
			referencePrefix: [input.referencePrefix],
			steps: this.fb.array(steps.map(item => item.formGroup)),//, Validators.required),
		})
		out.payload = input;
		out.form = form;
		out.steps = steps;
		// if (steps.length == 0) {
		// 	WrapperWorkflowStepDto.add(this.fb, out);
		// }
		return out;
	}
	addStep() {
		WrapperWorkflowStepDto.add(this.fb, this.workflow!);
		this.selectedStepIndex = this.workflow!.steps.length - 1;
	}
	removeStep({ index }: { index: number }) {
		WrapperWorkflowStepDto.remove(this.workflow!, index);
	}

	doSave() {
		const payload = this.workflow!.postBody;
		console.log("Payload", payload);
		if (this.workflow!.payload.id > 0) {
			this.httpService.edit(this.workflow!.payload.id, payload).subscribe(result => {
				this.draftService.removeDraft("workflow", this.workflow!.payload.id);
				this.router.navigate(['/workflow/list']);
			}, (error) => {
				this.messageService.error("Failed to create workflow");
			});
		} else {
			this.httpService.save(payload).subscribe(result => {
				this.draftService.removeDraft("workflow", this.workflow!.payload.id);
				this.router.navigate(['/workflow/list']);
			}, (error) => {
				this.messageService.error("Failed to update workflow");
			});
		}
	}
	doCancel() {
		this.router.navigate(['/workflow/list']);
	}
	getActiveStep(): WrapperWorkflowStepDto {
		if (this.selectedStepIndex < 0) {
			this.selectedStepIndex = 0;
		}
		if (this.selectedStepIndex >= this.workflow!.steps.length) {
			this.selectedStepIndex = this.workflow!.steps.length - 1;
		}
		return this.workflow!.steps[this.selectedStepIndex];
	}
	touchAllFields() {
		doTouchAllFields(this.workflow!.form);
	}
	saveAsDraft() {
		this.draftService.saveAsDraft("workflow", this.workflow!.payload.id > 0 ? this.workflow!.payload.id : 0, this.workflow?.postBody);
	}
	getInvalidControlsList() {
		return doGetInvalidControlsList(this.workflow!.form);
	}
}
